import React from 'react';
import PropTypes from 'prop-types';
import './BodyStyle.css'; // Import the CSS file

const BodyExtraSmallMedium = ({ text, color, whiteSpace }) => {
  return (
    <p className="body-extra-small-medium" style={{ color: color, whiteSpace: whiteSpace }}>
      {text}
    </p>
  );
};

BodyExtraSmallMedium.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default BodyExtraSmallMedium;